import AlignmentPopupContainer from './AlignmentPopupContainer';

export default AlignmentPopupContainer;